import * as bootstrap from 'bootstrap';

export default {
    data() {
        return {
            toast: null,
            toastMessage: '',
            toastTitle: '',
            toastError: false
        };
    },

    mounted() {
        this.toast = new bootstrap.Toast(document.getElementById('saveToast'));
    },

    methods: {
        showSuccessToast(title = 'Successo', message = 'Operazione completata con successo') {
            this.toastError = false;
            this.toastTitle = title;
            this.toastMessage = message;
            this.toast?.show();
        },

        showErrorToast(title = 'Errore', message = 'Si è verificato un errore') {
            this.toastError = true;
            this.toastTitle = title;
            this.toastMessage = message;
            this.toast?.show();
        }
    }
};
